import audienceComparison from './audience-comparison.png'
import audienceDemographicsIncomeAndEthnicity from './audience-demographics-income-and-ethnicity.png'
import audienceDemographicsKidsAndEducation from './audience-demographics-kids-and-education.png'
import audienceOverview from './audience-overview.png'
import audienceTrend from './audience-trend.png'
import audiencesToActivate from './audiences-to-activate.png'
import categoryCloud from './category-cloud.png'
import competitiveLandscape from './competitive-landscape.png'
import competitiveLandscapePie from './competitive-landscape-pie.png'
import competitiveLandscapeBar from './competitive-landscape-bar.png'
import competitiveSentiment from './competitive-sentiment.png'
import defaultImage from './default.png'
import deviceUsage from './device-usage.png'
import entityComparison from './entity-comparison.png'
import intro from './intro.png'
import marketing1 from './marketing-1.png'
import marketing2 from './marketing-2.png'
import marketing3 from './marketing-3.png'
import marketing4 from './marketing-4.png'
import marketing5 from './marketing-5.png'
import marketing6 from './marketing-6.png'
import outro from './outro.png'
import passionPoints from './passion-points.png'
import preferredSocialChannels from './preferred-social-channels.png'
import recentTrendsCategory from './recent-trends-category.png'
import recentTrendsTopics from './recent-trends-topics.png'
import sharethisOverview from './sharethis-overview2.png'
import topIndexingStates from './top-indexing-states.png'
import topicsCloud from './topics-cloud.png'
import transition from './transition.png'
import incomeDistribution from './demographics-income-distribution.png'
import incomeByAge from './demographics-income-by-age.png'
import incomeByGender from './demographics-income-by-gender.png'
import incomeByAgeAndGender from './demographics-income-by-age-and-gender.png'

const thumbnails = {
  defaultImage,
  Intro: intro,
  Outro: outro,
  Seasonality_by_Category: recentTrendsCategory,
  Seasonality: recentTrendsTopics,
  Audience_Comparison: audienceComparison,
  Audience_Trend: audienceTrend,
  Sentiment: competitiveSentiment,
  Competitive_Landscape: competitiveLandscape,
  Competitive_Landscape_Pie_Chart: competitiveLandscapePie,
  Competitive_Landscape_Bar_Chart: competitiveLandscapeBar,
  Entity_Comparison: entityComparison,
  Transition: transition,
  Recommended_Segments: audiencesToActivate,
  Audience_Overview: audienceOverview,
  L2_Categories_and_L3_Categories: passionPoints,
  Top_Indexing_States: topIndexingStates,
  Device_and_Mobile_OS: deviceUsage,
  Social_Networks: preferredSocialChannels,
  ShareThis_Overview: sharethisOverview,
  Marketing_1: marketing1,
  Marketing_2: marketing2,
  Marketing_3: marketing3,
  Marketing_4: marketing4,
  Marketing_5: marketing5,
  Marketing_6: marketing6,
  Topics_Cloud: topicsCloud,
  L2_and_L3_Categories_WordCloud: categoryCloud,
  Audience_Demographics_Income_And_Ethnicity: audienceDemographicsIncomeAndEthnicity,
  Audience_Demographics_Kids_And_Education: audienceDemographicsKidsAndEducation,
  Income_Distribution: incomeDistribution,
  Income_Distribution_by_Age: incomeByAge,
  Income_Distribution_by_Gender: incomeByGender,
  Income_Distribution_by_Age_and_Gender: incomeByAgeAndGender,
}

export default thumbnails
